import React, { Component } from "react";
import { useMemo, useContext } from "react";
import AppContext from "./AppContext";
import InterAxios from "./Service/InterAxios";

import Cookies from "universal-cookie";
const cookies = new Cookies();

const getAuthToken = () => {
  return cookies.get("authtoken")?.token;
};

class AppContextProvider extends Component {
  state = {
    interAxios: new InterAxios("App", getAuthToken),
    activeItem: "1",
  };

  constructor(props) {
    super(props);
  }

  setState(state) {
    super.setState(function (prevState, props) {
      let newState = { ...prevState, ...state };
      window.localStorage.setItem("state", JSON.stringify(newState));
      return {
        ...newState,
      };
    });
  }

  getState = () => {
    let stateStr = window.localStorage.getItem("state");
    let stateObj = JSON.parse(stateStr);
    return stateObj;
  };

  onSignIn = (responseData) => {
    cookies.set(
      "authtoken",
      {
        token: responseData.authToken,
      },
      { path: "/" },
    );
    cookies.set(
      "client",
      {
        status: responseData.subscriptionStatus,
        role: responseData.role,
      },
      { path: "/" },
    );

    this.setState({ loggedIn: true, isGyik: false });
  };

  /*onSignIn = () => {
    this.setState({loggedIn: true, isGyik: false});
  }*/

  onLogout = () => {
    cookies.remove("authtoken", { path: "/" });
    window.localStorage.removeItem("state");
    this.setState({ loggedIn: false, isGyik: true, isToVideoPage: false });
  };

  /*onLogout = () => {
     this.setState({loggedIn: false, isGyik: true});
   }*/

  isLoggedIn = () => {
    let cookieToken = getAuthToken();
    return cookieToken !== undefined && this.parseJwt(cookieToken)?.exp > Date.now() / 1000;
    //return this.state.loggedIn ? true : false;
  };

  parseJwt = (token) => {
    try {
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        window
          .atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join(""),
      );

      return JSON.parse(jsonPayload);
    } catch (e) {
      console.log(e);
      return null;
    }
  };

  openModal = (modalName) => {
    this.setState({
      loginModalOpened: true,
      modalName: modalName,
    });
    document.body.style.overflowY = "hide";
  };

  isModalOpened = () => {
    return this.getState()?.loginModalOpened;
  };

  closeModal = () => {
    this.setState({
      loginModalOpened: false,
    });
    document.body.style.overflowY = "scroll";
  };

  onSetActiveItem = (tab) => {
    this.setState({ activeItem: tab });
  };

  onGetPdf = (filename) => {
    this.state.interAxios.get("/storage/pdf/" + filename, function (response) {
      console.log(response.data);
    });
  };

  render() {
    return (
      <AppContext.Provider
        value={{
          interAxios: this.state.interAxios,
          isLoggedIn: this.isLoggedIn,
          onSignIn: this.onSignIn,
          onLogout: this.onLogout,
          getState: this.getState,
          isModalOpened: this.isModalOpened,
          openModal: this.openModal,
          closeModal: this.closeModal,
          onSetActiveItem: this.onSetActiveItem,
          onGetPdf: this.onGetPdf,
        }}
      >
        {this.props.children}
      </AppContext.Provider>
    );
  }
}

export default AppContextProvider;
